import 'froala-editor/js/plugins.pkgd.min.js'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import Vue from 'vue'
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
